import { Text, TextProps } from '@chakra-ui/react'
import { cx } from '@chakra-ui/utils'
import { PopoutIcon } from '~/Assets/icons'
import useNavigationActions from '~/hooks/useNavigationActions'
import { INavigationElement } from '~/types/generated/contentful'

export default function NavigationHyperLink({
  componentData,
  ...props
}: {
  componentData: INavigationElement
} & TextProps) {
  const action = useNavigationActions(componentData.fields)
  const externalIcon = componentData.fields?.type === 'External'

  return componentData.fields?.mainText ? (
    <Text
      className={cx('navigation-hyperlink', componentData.fields.htmlClasses)}
      variant="inherit"
      {...(action as any)}
      {...props}
      aria-label={componentData.fields.ariaLabel}
      title={componentData.fields.titleAttribute}
    >
      {componentData.fields.mainText}
      {externalIcon && <PopoutIcon aria-label="opens in new tab" />}
    </Text>
  ) : (
    <></>
  )
}
